module.exports = __webpack_public_path__ + "static/media/Admin-16.86f3a681.png";